export { default as useWindowSize } from './useWindowSize';
export * from './useWindowSize';
//# sourceMappingURL=index.js.map